var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightBtnAct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 183,
    viewBox: "0 0 101 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ma09nrn2za",
    x: 13.439,
    y: 41.816,
    width: 72.959,
    height: 105.658,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ma09nrn2za)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD569\\uCE58\\uAE30 1",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.622 74.193-6.254-6.694 27.078-28.987.638-.683-.638-.683L1.368 8.16l6.254-6.694 26.984 28.887 6.984 7.477-6.984 7.477L7.622 74.193z",
    style: {
      stroke: "none"
    },
    transform: "translate(28.44 53.82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.622 72.728 32.6-34.899-32.6-34.9-4.885 5.23 27.715 29.67-27.715 29.67 4.885 5.23m0 2.929L0 67.498 27.715 37.83 0 8.159 7.622 0l35.337 37.829-7.622 8.16L7.622 75.657z",
    style: {
      fill: "#9d9d9d",
      stroke: "none"
    },
    transform: "translate(28.44 53.82)"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 220",
    transform: "rotate(180 50.5 91.5)",
    style: {
      fill: "none"
    },
    d: "M0 0h101v183H0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBtnAct);
export default __webpack_public_path__ + "static/media/right_btn_act.e940c80fa4be8777c50910fb6a1951c6.svg";
export { ForwardRef as ReactComponent };